import React, { useEffect, useRef } from 'react';
import arrowIcon from '../../assets/arrow.svg';
import * as S from './GuidesList.styled';
export const GuidesList = ({ guides, categoryIndex, activeCategoryIndex, activeGuideIndex, onChange, onGuideSelect, }) => {
    const containerRef = useRef(null);
    useEffect(() => {
        if (containerRef.current) {
            containerRef.current.style.height =
                activeCategoryIndex === categoryIndex ? `${containerRef.current.scrollHeight}px` : `0px`;
            containerRef.current.style.transitionProperty = 'height';
        }
    }, [activeCategoryIndex, categoryIndex]);
    return (React.createElement(S.Container, { ref: containerRef, initiallyCollapsed: activeCategoryIndex !== categoryIndex }, guides.map((guide, guideIndex) => (React.createElement(S.GuideButton, { withIndicator: activeCategoryIndex === categoryIndex && guideIndex <= activeGuideIndex, key: `guide${categoryIndex}${guideIndex}`, active: activeCategoryIndex === categoryIndex && activeGuideIndex === guideIndex, onClick: () => {
            onGuideSelect?.();
            onChange(categoryIndex, guideIndex);
        } },
        React.createElement(S.ArrowIcon, null,
            React.createElement("img", { src: arrowIcon })),
        guide.title)))));
};
